import { useTranslate } from 'i18n-calypso';
import Content from 'components/content';
import ContentHeading from 'components/content/heading';
import Layout from 'components/layout';
import WPCloudSignupSidebar from 'sections/wpcloud/signup/sidebar';

interface Props {
	status?: number;
}

export default function WPCloudPartnershipRedirectError( {
	status,
}: Props ) {
	const translate = useTranslate();
	return (
		<Layout Sidebar={ WPCloudSignupSidebar }>
			<Content>
				<ContentHeading
					/* translators: %d is a numerical error code */
					section={ translate( 'Error %d', { args: [ status || 500 ] } ) }
					title={ translate( 'Uh oh. Something went wrong.' ) }
					description={ translate(
						'We were unable to check your partnership profile status. Please reach out to our helpful support team if this happens again.',
					) }
				/>
			</Content>
		</Layout>
	);
}
